exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".reset[data-v-c5e08dbc]{width:350px;max-width:100%}", "", {"version":3,"sources":["/home/runner/work/manager/manager/src/pages/ResetPassword.vue"],"names":[],"mappings":"AACA,wBACE,YAAa,AACb,cAAgB,CACjB","file":"ResetPassword.vue","sourcesContent":["\n.reset[data-v-c5e08dbc] {\n  width: 350px;\n  max-width: 100%;\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c5e08dbc","scoped":true,"hasInlineConfig":false}!./node_modules/stylus-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/ResetPassword.vue
// module id = 962
// module chunks = 20